export const CURRENT_USER_SET_RID = "CURRENT_USER_SET_RID"; 
export const CURRENT_USER_SET_FIRSTNAME = "CURRENT_USER_SET_FIRSTNAME"; 
export const CURRENT_USER_SET_LASTNAME = "CURRENT_USER_SET_LASTNAME";
export const CURRENT_USER_SET_LANGUAGE = "CURRENT_USER_SET_LANGUAGE";

export const CURRENT_USER_SET_USERNAME = "CURRENT_USER_SET_USERNAME"; 
export const CURRENT_USER_SET_ICONSMALL = "CURRENT_USER_SET_ICONSMALL"; 
export const CURRENT_USER_SET_ICONMEDIUM = "CURRENT_USER_SET_ICONMEDIUM"; 

export const CURRENT_USER_SET_ICONLARGE = "CURRENT_USER_SET_ICONLARGE"; 
export const CURRENT_USER_SET_IMAGESMALL = "CURRENT_USER_SET_IMAGESMALL"; 
export const CURRENT_USER_SET_IMAGEMEDIUM = "CURRENT_USER_SET_IMAGEMEDIUM"; 
export const CURRENT_USER_SET_IMAGELARGE = "CURRENT_USER_SET_IMAGELARGE"; 